import { Col } from '../../col';
import { useFormatMembersCount } from '../../header-content';
import { Icon } from '../../icon';
import { Row } from '../../row';
import { Text } from '../../typography';

export type ParticipantsProperties = {
  count: number;
  label: (formattedParticipantsCount: string) => string;
};

type P = {
  participants: ParticipantsProperties;
};

export const DataCardParticipants = ({ participants: { count, label } }: P) => {
  const formattedParticipantsCount = useFormatMembersCount({ count });

  return (
    <Row gutter={['xxs', 0]}>
      <Col>
        {/* TODO: icon inherits color from parent `a` and appears blue, we need to override its color */}
        <Icon color="text" icon="group-line" size="extra-small" />
      </Col>
      <Col>
        <Text size="small">{label(formattedParticipantsCount)}</Text>
      </Col>
    </Row>
  );
};
